
export enum AppStep {
  UPLOAD = 1,
  EXTRACTION = 2,
  DESIGN = 3,
  GENERATION = 4,
  CODE_VIEW = 5,
  PREVIEW = 6
}

export interface UIElement {
  type: string;
  text?: string;
  x: number;
  y: number;
  width: number;
  height: number;
  id: string;
}

export interface DesignSystem {
  colorPalette: {
    primary: string;
    secondary: string;
    background: string;
    text: string;
    accent: string;
  };
  typography: {
    fontFamily: string;
    baseSize: string;
  };
  effects: {
    borderRadius: string;
    shadow: string;
    animations: string[];
  };
}

export interface AppState {
  currentStep: AppStep;
  imageData: string | null;
  extractionData: UIElement[] | null;
  designData: DesignSystem | null;
  generatedCode: string | null;
  isProcessing: boolean;
  error: string | null;
}

export type Action =
  | { type: 'SET_STEP'; payload: AppStep }
  | { type: 'SET_IMAGE'; payload: string }
  | { type: 'SET_EXTRACTION'; payload: UIElement[] }
  | { type: 'SET_DESIGN'; payload: DesignSystem }
  | { type: 'SET_CODE'; payload: string }
  | { type: 'SET_PROCESSING'; payload: boolean }
  | { type: 'SET_ERROR'; payload: string | null }
  | { type: 'RESET' };
